import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=04008b9d&scoped=true&"
import script from "./roleManage.vue?vue&type=script&lang=js&"
export * from "./roleManage.vue?vue&type=script&lang=js&"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=04008b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04008b9d",
  null
  
)

export default component.exports